import type { ReactNode } from 'react'

import { HomeLauncherProvider } from '@coorum-research/core/src/components/HomeLauncher'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import { SessionProvider } from './SessionProvider'

const queryClient = new QueryClient()

export function LauncherProvider({ children }: {
  children: ReactNode
}) {
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <HomeLauncherProvider>
            {children}
          </HomeLauncherProvider>
        </SessionProvider>
      </QueryClientProvider>
    </React.StrictMode>
  )
}
